import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ManagementApiService } from '../../../../../services';
import { MatrixUsage } from '../../../enums/matrix-usage.enum';
import { UserMatrixModel } from '../../../models/user-matrix-model';
import { SuccessDialogComponent } from 'src/app/shared/info-dialogs/success-dialog/success-dialog.component';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
@Component({
    selector: 'app-matrix-create',
    templateUrl: './matrix-create.component.html',
    styleUrls: ['./matrix-create.component.scss'],
})
export class MatrixCreateComponent implements OnInit {
    @Output() refreshMatrix: EventEmitter<boolean> = new EventEmitter();
    @Output() newCreatedMatrix = new EventEmitter<any>();

    tooltip_position = 'above';
    closeResult: string;
    matrixAddFormGroup: UntypedFormGroup;

    constructor(
        private modalService: NgbModal,
        private fb: UntypedFormBuilder,
        private mgmtApi: ManagementApiService,
        private globalEmittersService: GlobalEmittersService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private User_utlity: UserUtilityService,
        private customValidatorService: CustomValidatorService
    ) {}

    ngOnInit(): void {
        this.matrixAddFormGroup = this.fb.group({
            matrixName: ['', Validators.required],
        });
    }

    open(content) {
        this.modalService
            .open(content, {
                ariaLabelledBy: 'modal-basic-title',
                backdrop: 'static',
                windowClass: 'my_modal_class',
                size: 'md',
                keyboard: false,
            })
            .result.then(
                (result) => {
                    this.closeResult = `Closed with: ${result}`;
                },
                (reason) => {
                    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                }
            );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    btnCreateMatrix() {
        if (this.matrixAddFormGroup.valid) {
            let matrix = new UserMatrixModel();
            matrix.name = this.matrixAddFormGroup.get('matrixName').value;
            matrix.usage = MatrixUsage.UserFacing;
            this.createMatrix(matrix);
            this.modalService.dismissAll();
        }
    }

    async createMatrix(matrix: UserMatrixModel) {
        this.ngxUiLoaderService.start();
        this.mgmtApi.createMatrix(matrix).subscribe(
            (result) => {
                this.ngxUiLoaderService.stop();
                if (result.success == true) {
                    let dialogRef = this.modalService.open(SuccessDialogComponent, {
                        size: 'md',
                    });
                    dialogRef.componentInstance.message = 'New matrix is added Sucessfully!';
                    this.globalEmittersService.refreshMatrix.subscribe((res) => {
                        if (res === true) {
                            this.newCreatedMatrix.emit(result.response);
                        }
                    });
                } else {
                    this.User_utlity.errorModelPopup(result.message);
                }
            },
            (err) => {
                this.ngxUiLoaderService.stop();
            }
        );
    }

    openFile() {
        document.querySelector('input').click();
    }

    handle(e) {}
    handleInputEvent(event: KeyboardEvent, typeOfValidation?: string) {
        const charCode = event.key;

        if (!/^[a-zA-Z0-9 ]$/.test(charCode)) {
            event.preventDefault();
        }
    }
}
